import { useQuery } from '@tanstack/react-query';
import { apiFetch } from './client';

// Server: flags/FlagController.java — GET /api/v1/flags returns every registered feature flag's
// resolved on/off state for the calling session (FeatureFlagService.allFor, keyed by the session's
// account id when present, else the anonymous-visitor rollout). A closed Record rather than a
// specific union of known codes: FeatureFlagService is a live, DB-backed registry (see
// ArenaFlagBootstrap for one example of a flag inserted at boot) — new codes can appear without a
// client deploy, and a caller checking a flag it doesn't recognize should read it as `undefined`
// (falsy), not a compile error.
export type FlagsDto = Record<string, boolean>;

export const flagsKeys = {
  all: ['flags'] as const,
};

export const getFlags = () => apiFetch<FlagsDto>('/flags');

export function useFlags() {
  return useQuery({ queryKey: flagsKeys.all, queryFn: getFlags });
}

/** Convenience read for a single flag code — `undefined`/not-yet-loaded and "flag absent from the
 *  response" both read as `false`, matching FeatureFlagService's own closed-world default (a flag
 *  with no row is off). */
export function useFlag(code: string): boolean {
  const { data } = useFlags();
  return data?.[code] ?? false;
}
